import { notifyError } from '@store/actionCreators/notifications';
import { QueryClient } from '@tanstack/react-query';
import { Dispatch } from 'redux';
import { STACK_STRINGS } from '../constants';

export const handleStackError = (
  error: unknown,
  isDefault: boolean | undefined,
  stackId: string | undefined,
  reduxDispatch: Dispatch,
  queryClient: QueryClient,
): void => {
  const errorWithCause = error as Error & { cause?: { message?: string } };
  const errorMessage = errorWithCause?.cause?.message;

  const isDuplicateDefaultStack =
    errorMessage?.includes('E11000 duplicate key error') &&
    errorMessage?.includes('00000000-0000-4000-8000-000000000000');

  if (isDuplicateDefaultStack) {
    notifyError(STACK_STRINGS.ERROR_DEFAULT_STACK_EXISTS)(reduxDispatch);
    queryClient.invalidateQueries({ queryKey: ['default-stack'] });
  } else {
    const notificationMessage = isDefault
      ? stackId
        ? STACK_STRINGS.ERROR_UPDATE_DEFAULT
        : STACK_STRINGS.ERROR_CREATE_DEFAULT
      : stackId
        ? STACK_STRINGS.ERROR_UPDATE
        : STACK_STRINGS.ERROR_CREATE;

    notifyError(notificationMessage)(reduxDispatch);
  }
};
